import styled from 'styled-components'
import Button from '@mui/material/Button'

export const SubmittedButton = styled(Button)`
&& {
width: 300px;
margin-top: 10px;
}
`

export const ConfirmedButton = styled(Button)`
&& {
margin-top: 16px;
}
`